module.exports = __webpack_public_path__ + "media/images/homes/Cloud-based-16-fa373ac3415222698e143d19dda2b434.png";